module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-300italic.woff2?b45d9997b704ab3daad1b5624eec1ad1";